<template>
  <div>
    <v-stepper-step :complete="step > stepConfig" step="!">
      Informe as datas
      <template v-if="step > stepConfig">
        <v-chip small class="mb-1 mt-1"
          >Data inicial: {{ formatarData(atestadoEnviar.datainicial) }}</v-chip
        >
        <v-chip small class="mb-1"
          >Dias atestado: {{ atestadoEnviar.diasatestado }}</v-chip
        >
        <v-chip small
          >Data final: {{ formatarData(atestadoEnviar.datafinal) }}</v-chip
        >
      </template>
    </v-stepper-step>
    <v-stepper-content :step="stepConfig">
      <v-card flat>
        <v-card-text class="pt-0 pb-0">
          <v-text-field
            type="date"
            label="Data inicial"
            v-model="atestadoEnviar.datainicial"
            @keyup="calculaDataFinal"
          ></v-text-field>
          <v-text-field
            label="Número de dias do atestado"
            type="number"
            v-model="atestadoEnviar.diasatestado"
            @keyup="calculaDataFinal"
            v-mask="'####'"
          ></v-text-field>
          <v-text-field
            v-if="getMotivoSelecionado().infdatafinal"
            type="date"
            label="Data final"
            v-model="atestadoEnviar.datafinal"
            readonly
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn
                rounded
                small
                color="info"
                @click="continuar()"
                class="mr-2"
                >Continuar</v-btn
              >
              <botao-anterior />
            </v-col>
          </v-row>
          <!--<botoes-stepper /> -->
        </v-card-actions>
      </v-card>
    </v-stepper-content>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapMutations, mapState } from "vuex";
//import BotoesStepper from "./BotoesStepper.vue";
import { dateFormat } from "@/global";
import BotaoAnterior from "./BotaoAnterior.vue";
export default {
  watch: {
    step: function (value) {
      if (value == this.stepConfig) {
        if (!this.atestSelec) {
          this.atestadoEnviar.diasatestado =
            this.getMotivoSelecionado().diasminimo;
          this.calculaDataFinal();
        }
      }
    },
  },
  components: { BotaoAnterior },
  computed: {
    ...mapState("atestado", ["atestadoEnviar", "step", "atestSelecs"]),
  },
  data: () => ({
    stepConfig: 40,
  }),
  methods: {
    ...mapGetters("atestado", ["getMotivoSelecionado"]),
    ...mapMutations("atestado", ["setNextStep"]),
    calculaDataFinal() {
      if (this.atestadoEnviar.diasatestado > 1) {
        this.atestadoEnviar.datafinal = moment(this.atestadoEnviar.datainicial)
          .subtract(1, "day")
          .add(this.atestadoEnviar.diasatestado, "day")
          .format("YYYY-MM-DD");
      } else this.atestadoEnviar.datafinal = this.atestadoEnviar.datainicial;
    },
    formatarData(value) {
      return dateFormat(value);
    },
    continuar() {
      if (
        this.atestadoEnviar.diasatestado <
        this.getMotivoSelecionado().diasminimo
      ) {
        this.$toasted.error(
          `A quantidade mínima de dias para este motivo é de ${
            this.getMotivoSelecionado().diasminimo
          } dias`
        );
        return;
      }

      if (
        this.atestadoEnviar.diasatestado >
        this.getMotivoSelecionado().diasmaximo
      ) {
        this.$toasted.error(
          `A quantidade máxima de dias para este motivo é de ${
            this.getMotivoSelecionado().diasmaximo
          } dias`
        );
        return;
      }

      this.setNextStep();
    },    
  },
};
</script>

<style>
</style>